export class StorageRepository {
    constructor(storage, localStorageKeyName) {
        this.storage = storage;
        this.localStorageKeyName = localStorageKeyName;
        this.VERSION_PREFIX = 'v2';
    }
    get() {
        const stringValue = this.storage.getItem(this.getKey());
        if (!stringValue) {
            return null;
        }
        return JSON.parse(stringValue);
    }
    set(value) {
        const stringValue = JSON.stringify(value);
        this.storage.setItem(this.getKey(), stringValue);
    }
    clear() {
        this.storage.removeItem(this.getKey());
    }
    getKey() {
        return `${this.VERSION_PREFIX}-${this.localStorageKeyName}`;
    }
}
